export const SITE_URL = "https://nepalfood.org";

export const orgJsonLd = (settings) => {
  const addr = settings?.address_lines || ["Himali Tole, Pokhara-17", "Gandaki Province, Nepal"];
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Nepal Food Networks",
    url: SITE_URL,
    logo: `${SITE_URL}/assets/img/mark-green.png`,
    email: settings?.contact_email || "hello@nepalfood.org",
    address: {
      "@type": "PostalAddress",
      streetAddress: addr[0] || "Himali Tole, Pokhara-17",
      addressRegion: (addr[1] || "Gandaki Province, Nepal").replace(/,\s*Nepal$/i, ""),
      addressCountry: "NP",
    },
    sameAs: (settings?.socials || []).map((s) => s.url).filter(Boolean),
  };
};

export const summitEventJsonLd = (summit) => ({
  "@context": "https://schema.org",
  "@type": "Event",
  name: summit.title,
  description: summit.theme,
  startDate: "2026-11-21",
  endDate: "2026-11-27",
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  eventStatus: "https://schema.org/EventScheduled",
  location: [
    { "@type": "Place", name: "Kathmandu", address: { "@type": "PostalAddress", addressLocality: "Kathmandu", addressCountry: "NP" } },
    { "@type": "Place", name: "Pokhara", address: { "@type": "PostalAddress", addressLocality: "Pokhara", addressCountry: "NP" } },
  ],
  organizer: { "@type": "Organization", name: "Social Gastronomy Movement", url: "https://www.socialgastronomy.org" },
});
